// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"96574bf6","732":"b1420dd7","787":"a5fa54f9"}[chunkId] + ".chunk.js";
};